
<template>
    <div>
       <div id="printdiv">
           <div class="contractTitle">
               {{contractcontent.name}}
           </div>
           <div class="contractNames">
               <div>甲方：{{contractcontent.jia}}</div>
               <div>乙方：{{contractcontent.yi}}</div>
               <div>乙方联系方式：{{contractcontent.yiPhone}}</div>
               <div v-if="contractcontent.yiIdCard||contractcontent.status==1">乙方身份证号：{{contractcontent.yiIdCard}}</div>
               <div>银行名称：{{contractcontent.yiBank}}</div>
               <div>开户行：{{contractcontent.yiKaiHu}}</div>
               <div>银行卡号：{{contractcontent.yiBankNum}}</div>
               <div v-if="contractcontent.type ==4">入场时间：{{contractcontent.yiIntime}}</div>
               <div>乙方所在工地：{{contractcontent.yiWorkPlace}}</div>
               <div>乙方用工类型：{{ worktype[contractcontent.worktype]}}</div>
               <div>乙方所属班组身份证号：{{contractcontent.groupidcard&&contractcontent.groupidcard}}</div>
               <div v-if="contractcontent.type!=1">乙方所属班组：{{contractcontent.yiBanZhu}}</div>
               <div v-if="contractcontent.type==2">乙方工作天数：{{contractcontent.yiWorkDays}}</div>
               <div v-if="contractcontent.type==1||contractcontent.type==5">乙方施工区域：{{contractcontent.yiWorkEare}}</div>
               <div v-if="contractcontent.type==1||contractcontent.type==2">已领取工资(含专户及私账)：{{contractcontent.yilingMoney}}</div>
               <div v-if="contractcontent.type==6">报销内容(发票及凭据上传)：
                   <div v-if="contractcontent.fapiaoUrl">
					<template v-for="src in getimgsrcs(contractcontent.fapiaoUrl)" >
						<img class="yiImg" :src="src"/>
					</template>
                   </div>
                </div>
           </div>
           <div class="contractContent">
               {{contractcontent.content}}
           </div>
           <div class="contracPrice" v-if="contractcontent.type !=4">
               <div>{{priceName[contractcontent.type]}}：{{contractcontent.jiesuanjine||contractcontent.price}}</div>
           </div>
           <div class="contractSign">
               <div class="jiaSign">
                   <div >
                       甲方签字或盖章: <img  style="height:45px" v-if="contractcontent.jiaSignUrl&&contractcontent.status == 3" :src="contractcontent.jiaSignUrl">
                   </div>
                   <div>
                        日期：<span v-if="contractcontent.status==3">{{contractcontent.jiaDate||""}}</span> 
                   </div>
               </div>
               <div class="yiSign">
                   <div>
                       乙方签字或盖章：<img style="height:45px" v-if="contractcontent.yiSignUrl" :src="contractcontent.yiSignUrl">
                   </div>
                   <div>
                        日期:{{contractcontent.yiDate||""}}
                   </div>
               </div>
           </div>
           <div class="yiIdCardImg" v-if="contractcontent.status != 1">
               乙方身份证正面照：
			   <template v-for="src in getimgsrcs(contractcontent.yiIdCardUrl)" >
			   		<img class="yiImg" :src="src"/>
			   </template>
           </div>
           <div class="yiIdCardImg" v-if="contractcontent.status != 1">
               银行卡正面照：
			   <template v-for="src in getimgsrcs(contractcontent.cardUrl)" >
			   		<img class="yiImg" :src="src"/>
			   </template>
           </div>
		   <div class="yiIdCardImg" v-if="contractcontent.type == 10 &&contractcontent.status >1 ">
               工资明细图：
			   <template v-for="src in getimgsrcs(contractcontent.gongzimingxitu)" >
			   		<img class="yiImg" :src="src"/>
			   </template>
           </div>
		   <div v-if="contractcontent.address">
				位置信息:
				{{ contractcontent.address }}	
		   </div>

		   <div v-if="contractcontent.type == 8" style="margin:10px 0">
				<h4>材料领取详情</h4>
				<div  style="display:flex;width:100%;">
					<div style="border:solid 1px #eeeeee;flex:1;padding:5px;">类型</div>
					<div style="border:solid 1px #eeeeee;flex:1;padding:5px;">单价</div>
					<div style="border:solid 1px #eeeeee;flex:1;padding:5px;">数量</div>
					<div style="border:solid 1px #eeeeee;flex:1;padding:5px;">小计</div>
				</div>
				<div v-for="item in typeof contractcontent.hetonglingquinfo == 'string'? JSON.parse(contractcontent.hetonglingquinfo):contractcontent.hetonglingquinfo" :key="item" style="display:flex;width:100%;">
					<div style="border:solid 1px #eeeeee;flex:1;padding:5px;">{{item.type}}</div>
					<div style="border:solid 1px #eeeeee;flex:1;padding:5px;">{{item.price}}元</div>
					<div style="border:solid 1px #eeeeee;flex:1;padding:5px;">{{item.number}}</div>
					<div style="border:solid 1px #eeeeee;flex:1;padding:5px;">{{item.total}}元</div>
				</div>
				
		   </div>

		   <div>
			   <span class="labelinfo">用工类型：</span>
				<a-select style="width:200px;margin-top:10px;" placeholder="用工类型" allowClear v-model ="contractcontent.worktype" >
					<a-select-option value="1">点工</a-select-option>
					<a-select-option value="2">带班</a-select-option>
					<a-select-option value="3">班组</a-select-option>
					<a-select-option value="4">材料商</a-select-option>
				</a-select>
		   </div>
		   <div v-if="contractcontent.type == 6">
			   <span class="labelinfo">报销类型：</span>
				<a-select style="width:200px;margin-top:10px;" placeholder="报销类型" allowClear v-model ="contractcontent.baoxiaotype" >
					<a-select-option v-for="item in baoxiaotypes"  :value="`${item.id}`" :key="item.id">{{item.name}}</a-select-option>
				</a-select>
		   </div>
			<div v-if="contractcontent.worktype == 3 || contractcontent.worktype == 1 ">
				<div>
			   		<span class="labelinfo">所属班组：</span>
					<a-input allowClear placeholder="所属班组" style="width:200px;margin-top:10px;" v-model="contractcontent.yiBanZhu"></a-input>
				</div>
				<div v-if="contractcontent.worktype == 3">
			   		<span class="labelinfo">班组身份证号码：</span>
					<a-input allowClear placeholder="班组身份证号码" style="width:200px;margin-top:10px;" v-model="contractcontent.groupidcard"></a-input>
				</div>
			</div>
			<div>
			   	<span class="labelinfo">乙方身份证号：</span>
				<a-input allowClear v-model="contractcontent.yiIdCard" style="width:200px;margin-top:10px;" placeholder="请输入身份证号码"></a-input>
			</div>
			<div>
			   	<span class="labelinfo">乙方姓名：</span>
				<a-input allowClear v-model="contractcontent.yi" style="width:200px;margin-top:10px;" placeholder="请输入乙方姓名"></a-input>
			</div>
		</div>
       <div class="btns">
           <div v-if="contractcontent.status == 2">
               <div class="pricein"  v-if="contractcontent.type != 4">
                   {{priceName[contractcontent.type]}}：<a-input style="width:100px" v-model="price"/>
               </div>
               <div class="pricebtn">
            		<a-button  type="primary" @click="goback">返 回</a-button>
                    <a-button type="primary" @click="confirmDel">删 除</a-button>
                    <a-button type="primary" @click="confirmCheck">审 核 通 过</a-button>
               </div>
           </div>
           <div class="pricebtn" v-if="contractcontent.status == 3">
            	<a-button  type="primary" @click="identityChecks" >检 测</a-button>
            	<a-button  type="primary" @click="goback">返 回</a-button>
                <a-button  type="primary" @click="saveinfo">保 存</a-button>
                <a-button  type="primary" @click="printcontract">合 同 导 出</a-button>
           </div>
       </div>
    </div>
</template>


<script>
import Detial from './data.js'
export default Detial
</script>
<style lang="less" scoped>
@import "index.less";
</style>


 


